module.exports = __webpack_public_path__ + "img/jf.03277e4a.png";